import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, exhaustMap, map, of } from "rxjs";
import { ApuResourceActions } from "./apu-resource.actions";
import { ApuResourceService } from "@/core/services/apu-resource.service";
import { ApuResourceApiModel } from "@/core/models/api/apu-resource-api.model";

@Injectable()
export class ApuResourceEffects {
    actions$ = inject(Actions);
    apuResource = inject(ApuResourceService);

    constructor(){

    }

    _loadApuCategoryList = createEffect(() => {
        return this.actions$.pipe(
            ofType(ApuResourceActions.loadApuResources),
            exhaustMap(() => {
                return this.apuResource.getAll().pipe(
                    map((response: any) => {
                        const apuResources = response as ApuResourceApiModel[];
                        return ApuResourceActions.loadApuResourceSuccess({ apuResources });
                    }),
                    catchError((error) => {
                        console.error(error);
                        return of();
                    })
                )
            })
        )
    });

    _addRange = createEffect(() => {
        return this.actions$.pipe(
            ofType(ApuResourceActions.addRangeApuResources),
            exhaustMap((action) => {
                return this.apuResource.addRange(action.apuResources).pipe(
                    map((response: any) => {
                        const apuResources = response as ApuResourceApiModel[];
                        return ApuResourceActions.addRangeApuResourceSuccess({ apuResources });
                    }),
                    catchError((error) => {
                        console.error(error);
                        return of();
                    })
                )
            })
        )
    });
}